import React, { useState, useEffect } from "react";
import Layout from "../Component/Layout";
import { BiSolidUser, BiCompass } from "react-icons/bi";
import REACT_APP_API_URL from "../utils/constant"



const Dashboard = () => {
  const [totalUser, setTotalUser] = useState(null);
  const [totalExplore, setTotalExplore] = useState(null);
  const [isLoading, setIsLoading] = useState(true); // Track loading state

  useEffect(() => {
    fetchDashboardData();
  }, []);

  const fetchDashboardData = async () => {
    try {
      let response = await fetch(`${REACT_APP_API_URL}dashboard`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("user")}`,
        },
      });

      const result = await response.json();
      console.log(">>>> Response:", result);

      if (result.code === 200) {
        setTotalUser(String(result.data));
        setTotalExplore(String(result.explore));
      } else {
        console.log("Invalid response:", result);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false); // Stop loading
    }
  };

  const DashboardLayout = [
    {
      path: "/users",
      icon: <BiSolidUser />,
      name: "Total Users",
      number: totalUser,
    },
    {
      path: "/explore",
      icon: <BiCompass />,
      name: "Explore",
      number: totalExplore,
    },
  ];

  return (
    <Layout>
      <div className="row">
        <div className="col-12">
          <div className="row">
            {DashboardLayout.map((item, index) => (
              <div className="col-lg-3 col-sm-6 mb-6" key={index}>
                <a href={item.path} className="card h-100">
                  <div className="card-body">
                    <div className="card-title d-flex align-items-start justify-content-between mb-4">
                      <div className="icons-bg flex-shrink-0">
                        <span className="fs-4" style={{ lineHeight: "24px" }}>
                          {item.icon}
                        </span>
                      </div>
                    </div>
                    <p className="mb-1">{item.name}</p>
                    
                    {isLoading ? (
                      <div className="shimmer-box"></div> // Shimmer effect
                    ) : (
                      <h4 className="card-title mb-0">{item.number || "0"}</h4>
                    )}
                  </div>
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Add shimmer effect styles */}
      <style>
        {`
          .shimmer-box {
            width: 100%;
            height: 20px;
            background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
            background-size: 200% 100%;
            animation: shimmer 1.5s infinite;
            border-radius: 4px;
          }
          
          @keyframes shimmer {
            0% { background-position: -200% 0; }
            100% { background-position: 200% 0; }
          }
        `}
      </style>
    </Layout>
  );
};

export default Dashboard;

// export default Dashboard;
